var map = {
	"./20231205_163315 (1).jpg": 126,
	"./20240523_161027.jpg": 7970,
	"./againJubilee.jpg": 4047,
	"./chandilDam.jpg": 8459,
	"./dorabjiTataPark.jpg": 3539,
	"./jubileePark.jpg": 2006,
	"./kaasPhool.jpg": 6965,
	"./natureTrail.jpg": 2498,
	"./rivers.jpg": 2029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9080;